
export const landingPageConfig = {
  appConfig: {
    
    logo: '/assets/images/logo.png',

    breadcrumb: [
      { label: 'Home', url: 'https://www.learnzapp.com' },
      { label: 'AI Certifications' }
    ],
    navItems: [
      { label: 'Home', url: '#home' },
      { label: 'Download', url: '#download' },
      { label: 'Features', url: '#features' },
      { label: 'Screenshots', url: '#screenshots' },
      { label: 'Pricing', url: '#pricing' }
    ],
    hero: {
      title: 'Master AI Certifications',
      subtitle1: 'Comprehensive prep for AIGP, CompTIA SecAI+, AWS AI Practitioner, AWS Machine Learning Engineer, GitHub Copilot, and CompTIA DataAI — with adaptive learning, detailed analytics, and expert-crafted content.',
      subtitle2: 'Start studying smarter today.',
      stats: [
        { value: '10K+', label: 'Active Users', icon:'users'},
        { value: '95%', label: 'Pass Rate', icon:'trophy' },
        { value: '1700+', label: 'Practice Questions', icon:'question-circle' }
      ],
      appIcon: '/assets/images/app-icon.png',
      heroImage: '/assets/images/hero-image.png',
      heroImageDark: '/assets/images/hero-image-dark.png',
      
    },
    studyAnywhere: {
      title: 'Study Anywhere',
      subtitle: 'Your progress syncs across all your devices - phones, tablets, and web. Start studying on your phone during your commute and continue on your laptop browser at home.',
    },

    // TODO(aicerts launch): when the apps are published, set the numeric App Store ID here and the
    // real store URLs in downloadLinks below. `appStoreId: null` + `url: '#'` are the "not yet
    // published" sentinels the consumers already guard on — MobileAppBanner.js skips the iOS Smart
    // App Banner on a falsy id and the Android intent on url === '#' — so no broken banner/buttons
    // render pre-launch (same `#` placeholder convention as footerLinks).
    appStoreId: null,
    androidPackage: 'com.learnzapp.aicerts',

    downloadLinks: [
      {
        store: 'Apple',
        title: 'App Store',
        url: '#'
      },
      {
        store: 'Google',
        title: 'Google Play',
        url: '#'
      }
    ]
  },

  featuresData: {
    title: 'Everything You Need to Succeed',
    subtitle: 'Comprehensive study tools designed specifically for AI certification success',
    
      "items": [
        {
          "icon": "chart-line",
          "title": "Readiness Score Analytics",
          "description": "Track your overall readiness and domain-specific performance with detailed analytics. See exactly where you stand and what to focus on next."
        },
        {
          "icon": "file-text",
          "title": "Study Articles & Questions",
          "description": "Expert-written articles covering key exam topics with mapped practice questions. Study the concept, then test your understanding immediately.",
          
        },
        {
          "icon": "tools",
          "title": "Custom Test Builder",
          "description": "Create personalized practice tests by selecting specific domains, difficulty levels, and question counts. Study exactly what you need."
        },
        {
          "icon": "calendar-day",
          "title": "Question of the Day",
          "description": "Build your study streak with daily questions. Track your progress and maintain momentum with just 2 minutes a day.",
          
        },
        {
          "icon": "users",
          "title": "Community Insights",
          "description": "See how other exam candidates answered each question. Learn from the community and understand common mistakes."
        },
        {
          "icon": "sync",
          "title": "Seamless Sync",
          "description": "Study on web, iOS, or Android. Your progress syncs automatically across all devices. Pick up exactly where you left off."
        },
        {
          "icon": "book",
          "title": "Comprehensive Resources",
          "description": "Flashcards, glossary, acronyms, and study guides. Everything you need in one place with regular content updates."
        },
        {
          "icon": "moon",
          "title": "Adaptive Interface",
          "description": "Dark/light mode support and responsive design. Study comfortably any time of day on any device."
        }
      ]
        
  },
  platforms: [
    {
      icon: 'laptop',
      title: 'Web Platform',
      description: 'Full-featured experience in your browser. Perfect for focused study sessions with detailed analytics.',
      ctaText: 'Sign In to Web App',
      ctaLink: 'https://app.learnzapp.com',
    },
    {
      icon: 'mobile-alt',
      title: 'Mobile Apps',
      description: 'Study on-the-go with native iOS and Android apps. Download for offline access and push notifications.',
      ctaText: 'Download Mobile App',
      ctaLink: '#downloads',
    },
    {
      icon: 'bullseye',
      title: 'Diagnostic Test',
      description: 'Not sure where to start? Take our free diagnostic test to assess your current knowledge and get a personalized study plan.',
      ctaText: 'Take Diagnostic Test',
      ctaLink: '#diagnostic',
    },
  ],

  screenshotsData: {
    title: "See It In Action",
    subtitle: "Explore our app's powerful features through these interactive screenshots",
    slides: [
      {
        "id": 1,
        "title": "Home Dashboard for Quick Access",
        "description": "Start studying instantly from the home screen with quick links to questions, tests, flashcards, and custom test creation.",
        "features": [
          "Overall readiness overview",
          "Daily question prompt",
          "Quick access to key study modes"
        ],
        "image": "/assets/images/screenshots/1.png"
      },
      {
        "id": 2,
        "title": "Light & Dark Mode Support",
        "description": "Choose between light and dark themes for comfortable studying in any environment.",
        "features": [
          "Easy theme switching",
          "Eye-friendly design",
          "Optimized for different lighting conditions"
        ],
        
        "image": "/assets/images/screenshots/2.png"
      },
      {
        "id": 3,
        "title": "Monitor Overall Exam Readiness",
        "description": "View your readiness score across all topics with detailed breakdowns to target weak areas.",
        "features": [
          "Overall readiness score gauge",
          "Topic-wise readiness percentages",
          "Performance history tracking"
        ],
        "image": "/assets/images/screenshots/3.png"
      },
      {
        "id": 4,
        "title": "Create Custom Practice Tests",
        "description": "Build tests tailored to your needs by topic, question count, time limit, and priority type.",
        "features": [
          "Select topics and number of questions",
          "Set time limits",
          "Prioritize incorrect, new, or bookmarked questions"
        ],
        "image": "/assets/images/screenshots/4.png"
      },
      {
        "id": 5,
        "title": "Answer with Confidence",
        "description": "Tackle multiple-choice questions in a clean, distraction-free interface for better focus and accuracy.",
        "features": [
          "Clear question and answer layout",
          "Multiple-choice options",
          "Timer to track pacing"
        ],
        "image": "/assets/images/screenshots/5.png"
      },
      {
        "id": 6,
        "title": "Track Progress in Each Test",
        "description": "Get instant feedback on your performance after each test with accuracy, time per question, and readiness score updates.",
        "features": [
          "Test score and accuracy breakdown",
          "Average time per question",
          "Readiness score improvement tracking"
        ],
        "image": "/assets/images/screenshots/6.png"
      },
      {
        "id": 7,
        "title": "Detailed Answer Explanations",
        "description": "Understand the reasoning behind correct answers with clear, concise explanations after each question.",
        "features": [
          "Highlights correct and incorrect answers",
          "In-depth explanations",
          "Immediate feedback to improve retention"
        ],
        "image": "/assets/images/screenshots/7.png"
      },
      {
        "id": 8,
        "title": "Learn from Community Insights",
        "description": "See how other learners performed on each question and measure your knowledge against the community.",
        "features": [
          "Community score for each question",
          "Percentage range of correct responses",
          "Benchmark your performance"
        ],
        "image": "/assets/images/screenshots/8.png"
      },
      {
        "id": 9,
        "title": "Master Concepts with Flashcards",
        "description": "Reinforce your knowledge using interactive flashcards designed to help you recall definitions and key concepts effortlessly.",
        "features": [
          "Simple question-answer format",
          "Terminology with definitions",
          "Supports quick self-testing"
        ],
        "image": "/assets/images/screenshots/9.png"
      },
      {
        "id": 10,
        "title": "Track Key AI Terms Easily",
        "description": "Quickly find and understand important AI and machine-learning certification terms with our searchable glossary for fast and effective learning.",
        "features": [
          "Alphabetical search for terms",
          "Clear, concise definitions",
          "Expandable sections for detailed explanations"
        ],
        "image": "/assets/images/screenshots/10.png"
      }
    ]
  },

  // NOTE(aicerts): exam format numbers (duration / question count / passing score) are drafted from
  // each cert's public exam guide — VERIFY against the current official guide before launch, as
  // vendors update formats.
  certificationData: {
    title: 'AI Certifications',
    subtitle: 'Prepare for AIGP, CompTIA SecAI+, AWS AI, Machine Learning, GitHub Copilot & CompTIA DataAI',
    items: [
      {
        title: 'IAPP Artificial Intelligence Governance Professional (AIGP)',
        domains: [
          'Foundations of AI',
          'AI Impacts & Responsible AI Principles',
          'AI Development Life Cycle',
          'AI Governance & Risk Management',
          'Laws & Standards Applying to AI'
        ],
        requirements: [
          'No formal prerequisites',
          'Pass the AIGP exam'
        ],
        experience: 'Recommended for privacy, legal, compliance, and governance professionals working with AI systems',
        benefits: [
          'First-of-its-kind AI governance credential',
          'Cross-functional AI leadership',
          'Regulatory and responsible-AI readiness',
          'Career differentiation'
        ],
        exam: {
          duration: '2.5 hours',
          questions: '100 questions',
          passingScore: '300 out of 500 (scaled)'
        }
      },
      {
        title: 'CompTIA SecAI+ (CY0-001)',
        domains: [
          'Basic AI concepts related to cybersecurity',
          'Securing AI systems',
          'AI-assisted security',
          'AI governance, risk, and compliance'
        ],
        requirements: [
          'No formal prerequisites',
          'Pass the CompTIA SecAI+ exam'
        ],
        experience: 'Recommended for security practitioners applying AI to cybersecurity and securing AI systems',
        benefits: [
          'Validate AI security fundamentals',
          'Secure AI systems and pipelines',
          'Apply AI to security operations',
          'AI governance, risk & compliance readiness'
        ],
        exam: {
          duration: 'See current exam guide',
          questions: 'See current exam guide',
          passingScore: 'See current exam guide'
        }
      },
      {
        title: 'AWS Certified AI Practitioner (AIF-C01)',
        domains: [
          'Fundamentals of AI and ML',
          'Fundamentals of Generative AI',
          'Applications of Foundation Models',
          'Guidelines for Responsible AI',
          'Security, Compliance & Governance for AI'
        ],
        requirements: [
          'No formal prerequisites',
          'Pass the AIF-C01 exam'
        ],
        experience: 'Recommended up to 6 months of exposure to AI/ML technologies on AWS',
        benefits: [
          'Validate foundational AI/ML fluency',
          'Cloud AI literacy',
          'Entry point to AI roles on AWS',
          'Vendor-recognized credential'
        ],
        exam: {
          duration: '90 minutes',
          questions: '65 questions',
          passingScore: '700 out of 1000'
        }
      },
      {
        title: 'AWS Certified Machine Learning Engineer (MLA-C01)',
        domains: [
          'Data Preparation for ML',
          'ML Model Development',
          'Deployment & Orchestration of ML Workflows',
          'ML Solution Monitoring, Maintenance & Security'
        ],
        requirements: [
          'No formal prerequisites',
          'Pass the MLA-C01 exam'
        ],
        experience: 'Recommended at least 1 year building, deploying, and operationalizing ML solutions on AWS',
        benefits: [
          'Validate production ML engineering skills',
          'MLOps proficiency',
          'High-demand AWS specialty',
          'Higher earning potential'
        ],
        exam: {
          duration: '130 minutes',
          questions: '65 questions',
          passingScore: '720 out of 1000'
        }
      },
      {
        title: 'GitHub Copilot Certification',
        domains: [
          'Responsible AI',
          'GitHub Copilot Plans & Features',
          'How Copilot Works & Handles Data',
          'Prompt Crafting & Prompt Engineering',
          'Developer Use Cases & Testing with Copilot'
        ],
        requirements: [
          'No formal prerequisites',
          'Pass the GitHub Copilot exam'
        ],
        experience: 'Recommended for developers using GitHub Copilot in their day-to-day workflow',
        benefits: [
          'Validate AI pair-programming skills',
          'Prompt-engineering fluency',
          'Modern developer credential',
          'Productivity differentiation'
        ],
        exam: {
          duration: '90 minutes',
          questions: '60 questions',
          passingScore: 'See current exam guide'
        }
      },
      {
        title: 'CompTIA DataAI (DY0-001)',
        domains: [
          'Mathematics and Statistics',
          'Modeling, Analysis, and Outcomes',
          'Machine Learning',
          'Operations and Processes',
          'Specialized Applications of Data Science'
        ],
        requirements: [
          'Recommended: 5+ years in a data science role',
          'Pass the DataAI (DY0-001) exam'
        ],
        experience: 'For experienced practitioners validating advanced data science and machine-learning expertise',
        benefits: [
          'Expert-level data science credential',
          'Deep machine-learning coverage',
          'Vendor-neutral across platforms',
          'Formerly CompTIA DataX'
        ],
        exam: {
          duration: '165 minutes',
          questions: 'Up to 90 questions',
          passingScore: 'Pass/fail'
        }
      }
    ]
  },

  

  contactData: {
    title: 'Contact Us',
    subtitle: 'Have questions? We\'re here to help'
  },

  footerData: {
    logo: '/assets/images/logo.png',
    description: 'Your trusted partner for AI certification exam preparation',
    socialLinks: [{
      url: 'https://www.linkedin.com/company/learnzapp',
      icon: '/assets/images/linkedin-icon.png'
    }],
    examLinksTitle: 'LearnZapp Exam Prep Apps',
    examLinks: [
      {
        name: 'ISC2 Official App',
        details: 'CISSP, CCSP and SSCP',
        icon: '/assets/images/app-icons/isc2.png',
        url: 'https://isc2.learnzapp.com'
      },
      {
        name: 'ISACA Official App',
        details: 'CISA, CISM and CRISC',
        icon: '/assets/images/app-icons/isaca.png',
        url: 'https://isaca.learnzapp.com'
      },
      {
        name: 'Cisco Exam Prep',
        details: 'CCNA and CCNP',
        icon: '/assets/images/app-icons/cisco.png',
        url: 'https://cisco.learnzapp.com'
      },
      { name:'CompTIA Security+',
        details: 'Security+',
        icon: '/assets/images/app-icons/securityplus.png',
        url: 'https://securityplus.learnzapp.com'
      },
      { name:'HR Certifications',
        details: 'HRCI PHR, SPHR and SHRM',
        icon: '/assets/images/app-icons/hr.png',
        url: 'https://hr.learnzapp.com'
      },
      { name:'Project Management Certifications',
        details: 'PMI PMP, CompTIA Project+',
        icon: '/assets/images/app-icons/projectmanagement.png',
        url: 'https://projectmanagement.learnzapp.com'
      },
      {
        name: 'CertMike CompTIA',
        details: 'IT+, A+, Network+',
        icon: '/assets/images/app-icons/certmike.png',
        url: 'https://certmike.learnzapp.com'
      },
      {
        name: 'FINRA Securities',
        details: 'SIE, Series 6, 7, 63, 65, 66',
        icon: '/assets/images/app-icons/finra.png',
        url: 'https://finra.learnzapp.com'
      },
      {
        name: 'Insurance Exam Prep',
        details: 'Life, Health, Property & Casualty',
        icon: '/assets/images/app-icons/insurance.png',
        url: 'https://insurance.learnzapp.com'
      }
    ],
    copyright: '© 2026 LearnZapp. All rights reserved.',
    footerLinks: [
      { name: 'Privacy Policy', url: '#' },
      { name: 'Terms of Service', url: '#' },
      { name: 'Contact', url: '#' },
      { name: 'Support', url: '#' }
    ]
  },

  // NOTE(aicerts): aggregate counts across the 6 exams — approximate; verify/round before launch.
  keyStats: {
    items: [
      {
        number: '1700+',
        label: 'Study Questions'
      },
      {
        number: '1500+',
        label: 'Glossary Terms'
      },
      {
        number: '580+',
        label: 'Flashcards'
      }
    ]
  },

  faqData: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our certification preparation platform',
    faqs: [
      {
        question: 'What certifications do you support?',
        answer: 'We currently support IAPP Artificial Intelligence Governance Professional (AIGP), CompTIA SecAI+ (CY0-001), AWS Certified AI Practitioner (AIF-C01), AWS Certified Machine Learning Engineer (MLA-C01), GitHub Copilot Certification, and CompTIA DataAI (DY0-001). Our platform provides comprehensive study materials, practice questions, and analytics designed specifically for these AI certifications.'
      },
      {
        question: 'How does the adaptive learning system work?',
        answer: 'Our adaptive learning system analyzes your performance across different domains and topics, identifying your strengths and areas for improvement. It then customizes your study plan, focusing on topics where you need more practice while reinforcing your strong areas.'
      },
      {
        question: 'Can I access the platform on multiple devices?',
        answer: 'Yes! Our platform is available on web browsers, iOS, and Android devices. Your progress automatically syncs across all devices, allowing you to study seamlessly whether you\'re at home or on the go.'
      },
      {
        question: 'What\'s included in the subscription plans?',
        answer: 'All subscription plans include access to our complete question bank, study materials, analytics dashboard, and practice tests. Longer-term plans offer additional savings and may include premium features like detailed performance analytics and personalized study recommendations.'
      },
      {
        question: 'How often is the content updated?',
        answer: 'We regularly update our content to align with the latest exam changes and industry best practices. Our team of certified professionals reviews and updates questions and study materials to ensure they reflect current exam requirements and industry standards.'
      },
      {
        question: 'Do you offer a money-back guarantee?',
        answer: 'Yes, we offer a 7-day money-back guarantee for our subscription plans. If you\'re not satisfied with our platform, you can request a full refund within the first 7 days of your subscription.'
      }
    ]
  }
}; 